import React, { useState } from 'react'
import { Title, Description, FurtherDesc } from '../common/System'
import Arrow from '../../img/arrow.webp'
import LoadInView from '../common/LoadInView'

interface propsType {
    searchWord : {search: string},
    formHandler: (e: React.ChangeEvent<HTMLInputElement>) => void,
    submitHandler: () => void
}

const ThemaSearch = (props: propsType) => {
  const [show, setShow] = useState(false)
  const handleShow = () => {
    if (show) {
        setShow(false)
    } else {
        setShow(true)
    }
  }     
  return (
    <>
        <Title>테마분석</Title>
        <Description>
          <div>테마분석을 지원하기 위해 만든 도구입니다. 검색하고 싶은 테마를 검색해보세요.</div>
          <div>예. 문제해결능력, 의사소통능력, 협업 등</div>
        </Description>
        <FurtherDesc isShow={show}>
          <div onClick={handleShow}>
            <img src={Arrow}  alt="arrow"/>
            상세 절차보기
          </div>
          {show?
            <LoadInView>
              <ol type="1">
                <li>사용자 검색어 입력</li>
                <li>사전학습된 정보를 활용하여 검색어 벡터계산</li>
                <li>학문프로파일 중 지식과 인접학과를 제외한 스킬, 흥미, 가치, 개인특성 데이터에 대하여</li>
                <li>항목과 설명 데이터를 병합하고, 그것의 벡터를 계산함</li>
                <li>계산된 약 만개의 학문프로파일 행과 검색어의 코사인 유사도 계산</li>
                <li>유사도가 높은 순으로 상위 20개 제시</li>
              </ol>
            </LoadInView>
            : <div></div>
          }
        </FurtherDesc>
        <form onSubmit={props.submitHandler}>
            <input
                type="text"
                id="word"
                name='word'
                value={props.searchWord.search}
                placeholder=' '
                onChange={(e) => props.formHandler(e)}
            />
            <label htmlFor='word'> 검색어 </label>
            <button> 검색 </button>
        </form>

    </>
  )
}

export default ThemaSearch